export function sendExperimentEvent(flag_name, flag_value) {
  const dataLayer = window.dataLayer || []

  if (
    flag_value !== null && flag_value !== undefined
  ) {
    dataLayer.push({
      event: 'experiment_viewed',
      experiment_id: flag_name,
      variation_id: flag_value ? '1' : '0',
    })
  }
}
